import React from "react";
import Parser from "html-react-parser";
import classes from "./Manual.module.scss";

export default class Manual extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <li className={`${classes.Wrapper} Wrapper`}>
        <span className={`${classes.LanguageCode} LanguageCode`}>
          {this.props.manual.field_manual_language_final
            .substring(0, 2)
            .toUpperCase()}
        </span>
        <span className={classes.ManualLink}>
          <a
            href={`${this.props.manual.manual_link}`}
            target="_blank"
            className={"Link"}
          >
            {Parser(this.props.manual.concat_link_text)}
          </a>
        </span>
      </li>
    );
  }
}
